export default __webpack_public_path__ + "static/media/balance-scale.3cb378dd.png";